import React, { useEffect, useState } from 'react';
import styles from './SplashScreen.module.css';

const SplashScreen = ({ onFinish }) => {
  // entering -> showing -> exiting -> done
  const [stage, setStage] = useState('entering');

  useEffect(() => {
    const t1 = setTimeout(() => setStage('showing'), 50);
    const t2 = setTimeout(() => setStage('exiting'), 900);
    const t3 = setTimeout(() => {
      setStage('done');
      if (onFinish) onFinish();
    }, 1300);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [onFinish]);

  if (stage === 'done') return null;

  return (
    <div
      className={`${styles.splash} ${
        stage === 'exiting' ? styles.exiting : ''
      }`}
      role="presentation"
      aria-hidden={stage === 'exiting'}
    >
      <div className={styles.glow} />
      <div className={styles.grid} />

      <div className={styles.content}>
        <img
          src={`${process.env.PUBLIC_URL || ''}/nube-data.svg`}
          alt="NuVe System"
          className={styles.logo}
        />

        <div className={styles.brand}>NuVe System</div>

        <div className={styles.progressTrack}>
          <div className={styles.progressBar} />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
